import { putLandings } from '../api/putLandings';

export const setPutLandings = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await putLandings(params);
            
            alert('Сохранено')
          
            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}